<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    center
    destroy-on-close
    :before-close="handleClose"
  >
    <div class="consult-pop-title flex-center">
      {{ $t("localization.succeedFont11") }}
    </div>
    <div class="consult-pop-remind flex-center black-6">
      {{ $t("localization.succeedFont12") }}
    </div>

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item
        :label="$t('localization.succeedFont13')"
        prop="customersName"
      >
        <el-input
          v-model="ruleForm.customersName"
          :placeholder="$t('localization.joinFont17')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('localization.succeedFont14')"
        prop="customersPhone"
      >
        <el-input
          v-model="ruleForm.customersPhone"
          :placeholder="$t('localization.joinFont18')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('localization.joinFont21')"
        prop="companyName"
      >
        <el-input
          v-model="ruleForm.companyName"
          :placeholder="$t('localization.joinFont24')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('localization.joinFont22')"
        prop="industry"
      >
        <el-input
          v-model="ruleForm.industry"
          :placeholder="$t('localization.joinFont25')"
        ></el-input>
      </el-form-item>
      
      <el-form-item
        :label="$t('localization.succeedFont15')"
        prop="customersAddress"
      >
        <el-cascader
          :placeholder="$t('localization.joinFont19')"
          :options="options"
          v-model="ruleForm.customersAddress"
          @change="addressChange"
          :props="{ label: 'name', value: 'name' }"
        ></el-cascader>
      </el-form-item>
      <el-form-item :label="$t('localization.joinFont23')" prop="demand">
        <el-input
          v-model="ruleForm.demand"
          :placeholder="$t('localization.joinFont26')"
          maxlength="100"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('localization.succeedFont16')" prop="remark">
        <el-input
          v-model="ruleForm.remark"
          :placeholder="$t('localization.joinFont20')"
          maxlength="100"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          class="confirm-but"
          type="primary"
          @click="confirmClick('ruleForm')"
          >{{ $t("localization.succeedFont17") }}</el-button
        >
        <el-button class="cancel-but" @click="cancelClick">{{
          $t("localization.succeedFont18")
        }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import address from "../../../static/address.json";
import { getConsult } from "@/api/index.js";
export default {
  props: {
    centerDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ruleForm: {
        customersName: "",
        customersPhone: "",
        customersAddress: [],
        remark: "",
        companyName:'',
        demand:'',
        industry:''
      },
      options: address,
      rules: {
        customersName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 1, max: 8, message: "长度在2到8个字符", trigger: "blur" }
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请输入行业", trigger: "blur" },
        ],
        demand: [
          { required: true, message: "请输入需求描述", trigger: "blur" },
        ],
        customersPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        customersAddress: [
          {
            required: true,
            message: "请选择所在城市",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    addressChange(val) {
      console.log(val)
      console.log( this.ruleForm.customersAddress)
    },
    cancelClick() {
      this.$emit("cancelHide");
      this.ruleForm = {
        customersName: "",
        customersPhone: "",
        customersAddress: [],
        remark: ""
      };
    },
    handleClose() {
      this.$emit("cancelHide");
      this.ruleForm = {
        customersName: "",
        customersPhone: "",
        customersAddress: [],
        remark: "",
        companyName:'',
        demand:'',
        industry:''
      };
    },
    confirmClick(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let location =
            this.ruleForm.customersAddress[0] +
            "/" +
            this.ruleForm.customersAddress[1] +
            "/" +
            this.ruleForm.customersAddress[2];
          this.ruleForm.customersAddress = location;
          getConsult(this.ruleForm).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "提交成功",
                type: "success"
              });
              this.handleClose()
            }else {
              this.$message({
                message: res.msg,
                type: "error"
              });
              this.handleClose()
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  z-index: 999999 !important;
}
/deep/ .el-dialog--center .el-dialog__body {
  padding: 25px 40px 25px 25px;
}
/deep/ .el-input__inner::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.8);
  font-family: "main-body";
}
/deep/ .el-textarea__inner::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.8);
  font-family: "main-body";
}
/deep/ .el-dialog__headerbtn {
  display: none;
}
/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .el-dialog {
  top: 50%;
  margin-top: 0 !important;
  transform: translate(0, -50%);
}
/deep/ .el-input__inner {
  background: #f2f3f5;
  color: rgba(0, 0, 0, 0.8);
  border: none;
}
/deep/ .el-cascader {
  flex: 1;
}
/deep/ .el-form-item__label {
  color: rgba(0, 0, 0, 0.8);
}
/deep/ .el-textarea__inner {
  max-height: 96px !important;
  min-height: 96px !important;
  background: #f2f3f5;
  color: rgba(0, 0, 0, 0.8);
  border: none;
  font-family: "main-body";
}
/deep/ .el-form-item__content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "main-body";
}
/deep/ .el-form-item {
    margin-bottom: 0px;
    margin-top: 18px;
  }
@media screen and (min-width: 768px) {
  .confirm-but {
    width: 100px;
    height: 40px;
    background: #2d64f1;
    border-radius: 4px 4px 4px 4px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin-right: 16px;
    margin-top: 10px;
  }
  .cancel-but {
    width: 100px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #2d64f1;
    font-size: 16px;
    font-weight: 400;
    color: #2d64f1;
    margin-right: 100px;
    margin-top: 10px;
  }
  .consult-pop-title {
    width: 100%;
    font-size: 24px;
    color: #000000;
    font-family: "biaoti";
  }
  .consult-pop-remind {
    font-size: 14px;
    font-family: "small-body";
    font-weight: 400;
    margin-top: 8px;
  }
  /deep/ .el-form {
    margin-top: 24px;
  }
  /deep/ .el-dialog {
    width: 543px !important;
    // height: 551px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
  }
}
@media screen and (min-width: 769px) {
}
@media screen and (min-width: 1024px) {
}
@media screen and (min-width: 1280px) {
}
@media screen and (min-width: 1600px) {
}
@media screen and (max-width: 767px) {
  /deep/ .el-dialog--center .el-dialog__body {
    padding: 25px 25px 25px 25px;
  }
  /deep/ .el-dialog {
    width: 90% !important;
    min-height: 520px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
  }
  .confirm-but {
    width: 80px;
    height: 34px;
    background: #2d64f1;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    margin-right: 16px;
    line-height: 8px;
  }
  .cancel-but {
    width: 80px;
    height: 34px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #2d64f1;
    font-size: 14px;
    font-weight: 400;
    color: #2d64f1;
    margin-right: 70px;
    line-height: 8px;
  }
  .consult-pop-title {
    width: 100%;
    font-size: 18px;
    color: #000000;
    font-family: "biaoti";
  }
  .consult-pop-remind {
    font-size: 12px;
    font-family: "small-body";
    font-weight: 400;
    margin-top: 8px;
  }
  /deep/ .el-form {
    margin-top: 20px;
  }
  /deep/ .el-textarea__inner {
    font-size: 12px;
  }
  /deep/ .el-input__inner {
    font-size: 12px;
  }
  /deep/ .el-form-item__label {
    font-size: 12px;
    width: 78px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 78px !important;
    
  }
 
}
</style>



// WEBPACK FOOTER //
// src/components/common/consult-pop.vue